import { Injectable } from '@angular/core';
import {throwError as observableThrowError,  Observable, of as observableOf } from 'rxjs';
import { ApiService } from './api.service';
import { IBanners } from '../interfaces/banners';
import { IBanner } from '../interfaces/banner';
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BannersService {

  constructor(private _apiService: ApiService) { }

  list(local) : Observable<IBanners>  {
    return this._apiService.doGET('banners?local='+local)
      .pipe(catchError(err => {
        return observableThrowError(err.error_message)
      }))
  }

  show(id: number) : Observable<IBanner>  {
    return this._apiService.doGET('banners/'+id)
      .pipe(catchError(err => {
        return observableThrowError(err.error_message)
      }))
  }

  store(data) : Observable<any> {
    return this._apiService.doPOST('banners', data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  patch(idbanner, data) : Observable<any> {
    return this._apiService.doPATCH('banners/'+idbanner, data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  patchOrdem(data) : Observable<any> {
    return this._apiService.doPATCH('banners/ordem', data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  delete(idbanner, local) : Observable<any> {
    return this._apiService.doDELETE('banners/'+idbanner+'?local='+local)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  removeImage(idbanner, tipo) : Observable<any> {
    return this._apiService.doDELETE('banners/'+idbanner+'/image?tipo='+tipo)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  showRegions() : Observable<any>  {
    return this._apiService.doGET('banner-regions')
      .pipe(catchError(err => {
        return observableThrowError(err.error_message)
      }))
  }

  showConfig(local: string) : Observable<any>  {
    return this._apiService.doGET('banner-config/'+local)
      .pipe(catchError(err => {
        return observableThrowError(err.error_message)
      }))
  }

  storeConfig(data) : Observable<any> {
    return this._apiService.doPOST('banner-config', data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }
}
